export interface Recipe {
  image_url?: string;
  name: string;
  url: string;
}

class RelatedRecipe {
  protected imageUrl: string;
  protected name: string;
  protected url: string;
  private rank?: number;

  constructor(recipe: Recipe, blankLogoSrc: string, rank?: number) {
    this.imageUrl = recipe.image_url || blankLogoSrc;
    this.name = recipe.name;
    this.url = recipe.url;
    this.rank = rank;
  }

  protected rankPrefix(): string {
    if (this.rank === undefined) {
      return "";
    }
    const rankNum = parseInt(String(this.rank), 10);
    if (Number.isNaN(rankNum)) {
      return "";
    }
    return `${rankNum}位 `;
  }

  protected escapeHtml(text: string): string {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  toHtml(): string {
    const escapedName = this.escapeHtml(this.name);
    return `
      <div class="recipe_box">
        <a href="${this.url}" target="_blank">
          <img src="${this.imageUrl}" />
          <br />
          ${this.rankPrefix()}${escapedName}
        </a>
      </div>
    `;
  }
}

export { RelatedRecipe };
